import {State} from "./State";

export class PauseState extends State {

    init(data?: any): void {
    }

    update(delta: number): void {
    }

    render(): void {
    }

    stop(): void {
    }

    pauseState(): void {
    }

    resumeState(): void {
    }

}


// WEBPACK FOOTER //
// ./app/src/state/PauseState.ts